export const MESSAGE_SENDER = 'MESSAGE_SENDER';
